import { useMutation, useQueryClient } from '@tanstack/react-query';
import { promotionsService } from '../services/promotions.service';
import type { UpdatePromotionData } from '../types/promotions.types';

export function useUpdatePromotion() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ refId, data }: { refId: string; data: UpdatePromotionData }) =>
      promotionsService.updatePromotion(refId, data),
    onSuccess: (_, { refId }) => {
      queryClient.invalidateQueries({ queryKey: ['promotions'] });
      queryClient.invalidateQueries({ queryKey: ['promotion', refId] });
    },
  });
}
